// notifications.ts
import client from './client';

export interface SendUnsubmittedNotificationResponse {
  success: boolean;
  message: string;
  employeeCount?: number;
  notificationResult?: {
    totalSuccessCount: number;
    totalFailureCount: number;
    englishBatches: number;
    spanishBatches: number;
  };
}

// Function to send push notification reminder for unsubmitted timesheets
export const sendUnsubmittedNotification = async (payPeriodID: number): Promise<SendUnsubmittedNotificationResponse> => {
  try {
    // Ensure that payPeriodID is provided
    if (!payPeriodID) {
      throw new Error("PayPeriodID is required.");
    }

    // Make the API request to the notification endpoint
    const response = await client.post<SendUnsubmittedNotificationResponse>('/admin/notifications/sendUnsubmittedNotification', {
      payPeriodID
    });

    // Return the response data
    return response.data;

  } catch (error: any) {
    // Log any errors that occur during the notification process
    console.error("Error sending notification:", error);
    
    // Extract error message from response if available
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to send notification.";
    
    // Return error response
    return {
      success: false,
      message: errorMessage
    };
  }
};


